export default "/_next/static/images/wag-ball-2x-c5bfac5c50bba9977d23cfd08842fa08.png";